import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShift"><Path d="M12.0012 1.64783L0.53125 14H6.11958V21H17.8827V14H23.4711L12.0012 1.64783Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShift;
